import { render, staticRenderFns } from "./profilzorunlubilgiler.vue?vue&type=template&id=7e6494fe&scoped=true&"
import script from "./profilzorunlubilgiler.vue?vue&type=script&lang=js&"
export * from "./profilzorunlubilgiler.vue?vue&type=script&lang=js&"
import style0 from "./profilzorunlubilgiler.vue?vue&type=style&index=0&id=7e6494fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6494fe",
  null
  
)

export default component.exports